import React from 'react';
import PropTypes from 'prop-types';

class SelectPSKubun extends React.Component {
  constructor(props) {
    super(props);
    this.handleOptionChange = this.handleOptionChange.bind(this);
  }

  // Arrow Functionを使わずにメソッドを定義
  handleOptionChange(event) {
    this.setState({ selectedOption: event.target.value });
    // 選択された値に基づいて外部アクションをトリガーします
    this.props.actions.changePSKubun(event.target.value);
  }

  render() {
    const defaultValue = this.props.data.pskubun;
    const isReadOnly = this.props.isReadOnly;
    const disabledLabelClass = isReadOnly ? 'disabled_label' : '';
    let className = 'switchPs switchPs-and-rate-size ';
    if (location.pathname.indexOf('K014') === 1) {
      className = 'switchPs switchPs-and-rate-size_k014 ';
    }

    return (
      <div>
        <div id="switchPs" className={className}>
          <input type="radio" name="psKubun" id="pachinko" value="0" checked={defaultValue == 0} onChange={this.handleOptionChange} readOnly={isReadOnly} />
          <label htmlFor="pachinko" className={`${disabledLabelClass} ${defaultValue == 0 ? 'switch-on' : 'switch-off'}`}>パチンコ</label>
          <input type="radio" name="psKubun" id="slot" value="1" checked={defaultValue == 1} onChange={this.handleOptionChange} readOnly={isReadOnly} />
          <label htmlFor="slot" className={`${disabledLabelClass} ${defaultValue == 1 ? 'switch-on' : 'switch-off'}`}>スロット</label>
        </div>
      </div>
    );
  }
}

SelectPSKubun.propTypes = {
  actions: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
};

export default SelectPSKubun;
